import { render, staticRenderFns } from "./IconPercent.vue?vue&type=template&id=411f363c&"
import script from "./IconPercent.vue?vue&type=script&lang=js&"
export * from "./IconPercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports